import BigNumber from 'bignumber.js';
import { BigNumberConstructable } from '../lib/customType';

/**
 * @param amount in base unit
 */
export default function formatCrypto(amount: BigNumberConstructable, decimals: number): string {
  return new BigNumber(amount).shiftedBy(-decimals).toFixed();
}
